// Import images from assets (you can populate these with actual press release images)
import pressReleaseDefaultImage from "../../assets/images/press-releases/Comsense-Technologies-Unveils-IntellSense-A-Self-Service-Business-Intelligence-and-Reporting-Tool.webp";
import martechAwardImage from "../../assets/images/press-releases/MarTech-Award.JPG";

export const pressReleases = [
  {
    id: 1,
    title:
      "Comsense Technologies Unveils IntellSense: A Self-Service Business Intelligence and Reporting Tool",
    category: "",
    date: "",
    author: "Sagar Babar",
    excerpt: "",
    image: pressReleaseDefaultImage,
    slug: "comsense-technologies-unveils-intellsense-a-self-service-business-intelligence-and-reporting-tool",
  },
  {
    id: 2,
    title:
      "Comsense Technologies Wins Three Prestigious MarTech Awards for Customer Experience and Marketing Innovation",
    category: "Awards & Recognition",
    date: "28 May 2026",
    author: "Comsense Technologies",
    excerpt:
      "Comsense Technologies has been honored with three prestigious MarTech Awards, recognizing its work in delivering data-driven customer engagement, marketing analytics, and customer experience transformation for leading automotive brands.",
    image: martechAwardImage,
    hideFeaturedImage: true,
    slug: "comsense-technologies-wins-three-prestigious-martech-awards-for-customer-experience-and-marketing-innovation",
  },
];
